import React from 'react';
import HorizontalLinks from '../Links/HorizontalLinks';

const supportLinks = [
  { title: 'AppOptics', url: 'https://www.appoptics.com/contact' },
  { title: 'Loggly', url: 'https://www.loggly.com/docs-index/' },
  { title: 'Papertrail', url: 'https://papertrailapp.com/plans/contact' },
  { title: 'Pingdom', url: 'https://www.pingdom.com/company/contact' },
];

export const ProductSupportLinks = props => <HorizontalLinks {...props} items={supportLinks} />;
